export default [
  // *===============================================---*
  // *--------- TRACEABILITY -------------------------------------------*
  // *===============================================---*
  {
    path: '/trazabilidad/:loggable_type/:loggable_id',
    name: 'traceability',
    component: () => import('@/views/traceability/Traceability.vue'),
  },
]